import { initialize } from 'store/create';
import { initializeGoogle } from 'utils/search/autocomplete';

const initializeApp = ({ dispatch, getState }) => {
	const { app } = getState();

	initializeGoogle({
		key: app.googleMapsKey,
	});

	dispatch(initialize());
};

export default initializeApp;
